import type { Memo } from './types.js';

/**
 * Last-Write-Wins merge.
 * - Higher updatedAt wins.
 * - On equal updatedAt, a tombstone (deletedAt non-null) wins.
 * - Otherwise either side is acceptable; we return `a`.
 */
export function mergeLWW(a: Memo, b: Memo): Memo {
  if (a.updatedAt > b.updatedAt) return a;
  if (a.updatedAt < b.updatedAt) return b;
  if (a.deletedAt && !b.deletedAt) return a;
  if (b.deletedAt && !a.deletedAt) return b;
  return a;
}
